import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaStethoscope, FaFlask, FaClipboardList } from "react-icons/fa";
import ConfirmModal from "../Popups/ConfirmModal";

const categories = [
  { name: "Doctor Consultation", label: "Doctor Consultation", shortLabel: "Consult", icon: FaStethoscope },
  { name: "Lab Test & Packages", label: "Lab Test & Packages", shortLabel: "Lab Tests", icon: FaFlask },
  { name: "Health Risk Assessment", label: "Health Risk Assessment", shortLabel: "HRA", icon: FaClipboardList },
];

const CategoriesPage = ({ mobileTop = false }) => {
  const [showComingSoon, setShowComingSoon] = useState(false);
  const navigate = useNavigate();

  const handleCategoryClick = (categoryName) => {
    if (categoryName === "Doctor Consultation") {
      navigate("/consultations");
    } else if (categoryName === "Lab Test & Packages") {
      navigate("/lab-tests");
    } else if (categoryName === "Health Risk Assessment") {
      navigate("/hra-category");
    } else {
      setShowComingSoon(true);
    }
  };

  return (
    <div>
      <h2 className={`font-semibold text-on-primary-fixed-var mb-4 ${mobileTop ? "text-base" : "text-lg"}`}>
        Quick Actions
      </h2>
      <div className="grid grid-cols-3 gap-2 sm:gap-4">
        {categories.map((category) => {
          const Icon = category.icon;
          return (
            <div
              key={category.name}
              role="button"
              tabIndex={0}
              className={`card flex flex-col items-center justify-center cursor-pointer hover:border-primary/50 hover:shadow-md transition-all duration-200 ${
                mobileTop
                  ? "p-3 min-h-[96px]"
                  : "p-3 sm:p-6 min-h-[96px] sm:min-h-[140px]"
              }`}
              onClick={() => handleCategoryClick(category.name)}
              onKeyDown={(e) => e.key === "Enter" && handleCategoryClick(category.name)}
            >
              <div
                className={`bg-primary-fixed/40 rounded-full flex items-center justify-center mb-2 ${
                  mobileTop ? "w-10 h-10" : "w-10 h-10 sm:w-14 sm:h-14 sm:mb-4"
                }`}
              >
                <Icon className={`text-primary ${mobileTop ? "w-[18px] h-[18px]" : "w-[18px] h-[18px] sm:w-6 sm:h-6"}`} />
              </div>
              <p
                className={`font-semibold text-on-primary-fixed-var text-center leading-tight ${
                  mobileTop ? "text-[11px]" : "text-[11px] sm:text-sm"
                }`}
              >
                {mobileTop ? category.shortLabel : category.label}
              </p>
            </div>
          );
        })}
      </div>

      <ConfirmModal
        open={showComingSoon}
        title="Coming Soon"
        message="This feature will be available soon. Stay tuned!"
        confirmLabel="Okay"
        cancelLabel={null}
        onConfirm={() => setShowComingSoon(false)}
        onCancel={() => setShowComingSoon(false)}
      >
        <img
          src="https://i.gifer.com/TweA.gif"
          alt="Coming Soon"
          className="w-24 h-24 sm:w-32 sm:h-32 object-contain mb-4 mx-auto"
        />
      </ConfirmModal>
    </div>
  );
};

export default CategoriesPage;
